import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import { Button } from '../../shared/components/Button'
import { languageUtil } from '../../util/languageUtils'

export default function Card({
    imageSrc,
    label,
    description,
    buttonLabel = 'Learn More',
    onButtonClick,
    buttonVariant = 'secondary', // Changed default to secondary
    buttonSize = 'medium',
    children,
    button = true,
    category = [],
}) {
    const { language } = languageUtil()
    const rtl = language === 'ar'

    return (
        <div className='flex flex-col h-full overflow-hidden transition-all duration-300 bg-white border border-gray-200 shadow-sm group rounded-xl hover:shadow-md hover:border-gray-300'>
            {/* Image container with subtle effects */}
            {imageSrc && (
                <div className='relative overflow-hidden bg-gray-50'>
                    <img
                        src={imageSrc}
                        alt={label}
                        className='object-cover w-full h-48 transition-transform duration-500 group-hover:scale-105'
                    />
                    {/* Subtle overlay gradient */}
                    <div className='absolute inset-0 bg-gradient-to-t from-white/10 to-transparent'></div>
                </div>
            )}

            {/* Content */}
            <div className='flex flex-col flex-grow p-5'>
                {/* Category tags */}
                {Array.isArray(category) && category.length > 0 && (
                    <div className='flex flex-wrap gap-2 mb-3'>
                        {category.map((cat, idx) => (
                            <span
                                key={idx}
                                className='inline-block px-3 py-1 text-xs font-medium border rounded-full text-amber-700 bg-gradient-to-r from-amber-50 to-yellow-50 border-amber-100'
                            >
                                {cat}
                            </span>
                        ))}
                    </div>
                )}

                {/* Label */}
                <h3 className='mb-2 text-lg font-semibold text-gray-900 transition-colors group-hover:text-gray-800'>
                    {label}
                </h3>

                {/* Description with limited lines */}
                {description && (
                    <p className='flex-grow mb-4 text-sm text-gray-600 line-clamp-3'>
                        {description}
                    </p>
                )}

                {/* Children content */}
                {children && <div className='mb-4'>{children}</div>}

                {/* Bottom Button - Elegant styling */}
                {button && (
                    <div className='pt-4 mt-auto border-t border-gray-100'>
                        <Button
                            onClick={onButtonClick}
                            variant={buttonVariant}
                            size={buttonSize}
                            className='justify-center w-full text-gray-700 transition-all duration-300 border border-gray-300 bg-gradient-to-r from-white to-gray-50 hover:from-gray-50 hover:to-gray-100 hover:text-gray-900 hover:border-gray-400 group/btn'
                        >
                            <span className='inline-block transition-transform duration-300 group-hover/btn:translate-x-1'>
                                {buttonLabel}
                            </span>
                            {rtl ? (
                                <FaArrowLeft className='transition-transform duration-300 transform group-hover/btn:translate-x-1' />
                            ) : (
                                <FaArrowRight className='transition-transform duration-300 transform group-hover/btn:translate-x-1' />
                            )}
                        </Button>
                    </div>
                )}
            </div>

            {/* Decorative accent */}
            <div className='h-1 transition-all duration-300 bg-gradient-to-r from-transparent via-gray-100 to-transparent group-hover:via-amber-200'></div>
        </div>
    )
}
